// extracted by mini-css-extract-plugin
module.exports = {"catering_packages_slider":"_2VaRT","ellipsis":"_3eYOY"};